export default process.env.REACT_APP_VERSION;
